


































import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'

interface CampoQueVaiMudar {
  campo: string
  antes: string
  depois: string
}

@Component
export default class ComponentModalConfirmaSobrescritaPacienteHisBackoffice extends Vue {
  @Prop() visible: boolean
  @Prop() camposQueVaoMudar: CampoQueVaiMudar[]
  @Prop() loading: boolean

  show: boolean = false

  @Watch('visible')
  onVisibilityChange(visible: boolean) {
    this.show = visible
  }

  @Emit('cancelar')
  cancelar() {}

  @Emit('confirmar')
  confirmar() {}
}
